import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=6e7ce31b&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ce31b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/src/Web/InternetBranch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7ce31b')) {
      api.createRecord('6e7ce31b', component.options)
    } else {
      api.reload('6e7ce31b', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=6e7ce31b&scoped=true", function () {
      api.rerender('6e7ce31b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangePassword.vue"
export default component.exports